import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

export const AirOriginChargeDetails = () => {

    const history = useHistory()
    // eslint-disable-next-line
    const [data, setData] = useState(history.location.state)

    return (
        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 border-end">
                                            <h5 className="secHeading">County Details</h5>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Staus - </td>
                                                        <td className="py-1 text-success" >{data.local_origin_charge_status}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Country Name - </td>
                                                        <td className="py-1">{data.country.country_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">ISO 2 - </td>
                                                        <td className="py-1">{data.country.country_iso2}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">ISO 3 - </td>
                                                        <td className="py-1">{data.country.country_iso3}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Currency - </td>
                                                        <td className="py-1">{data.country.country_currency}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Dial Code - </td>
                                                        <td className="py-1">{data.country.country_dial_code}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-lg-4 col-md-6">
                                            <h5 className="secHeading">Normal Value</h5>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Airline Handling - </td>
                                                        <td className="py-1">{data.airline_handling}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Customs Docs - </td>
                                                        <td className="py-1">{data.customs_docs}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Handling In - </td>
                                                        <td className="py-1">{data.handling_in}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Handling Out - </td>
                                                        <td className="py-1">{data.handling_out}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Transport s2d - </td>
                                                        <td className="py-1">{data.transport_s2d_to_apt}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">AWB Fee - </td>
                                                        <td className="py-1">{data.awb_fee}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="col-lg-4 col-md-6 border-end">
                                            <h5 className="secHeading">Minimum Value</h5>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Min Airline Handling - </td>
                                                        <td className="py-1">{data.min_airline_handling}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Min Customs Docs - </td>
                                                        <td className="py-1">{data.min_customs_docs}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Min Handling In - </td>
                                                        <td className="py-1">{data.min_handling_in}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Min Handling Out - </td>
                                                        <td className="py-1">{data.min_handling_out}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Min Transport s2d - </td>
                                                        <td className="py-1">{data.min_transport_s2d_to_apt}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}